export default __webpack_public_path__ + "static/media/fotoFormSolucoes.460fc6d8.svg";